import { format } from 'date-fns';
import { ConsiderationType } from 'further-types/exit';
import { ExitDetailsFormValues } from '../../ExitDetailsForm';
import { StagedShareholding } from '../../ExitDetailsForm/types';

type SharedShareConsiderationFields = {
  shareConsiderationCompanyId?: string;
  shareConsiderationShareClassId?: string;
  totalConsiderationShares?: number;
  shareConsiderationValuePerShare?: number;
  shareConsiderationValueTotal?: number;
  shareConsiderationEisEligible?: boolean;
  shareConsiderationAllocationMethod?: string;
  permitPartialShareAllocation?: boolean;
};

export type StageAmendmentInput = {
  exitId: string;
  exitDate: string;
  firmId: string;
  sharePrice: number;
  taxableValueSharePrice: number;
  isReceivedValueSharePriceUnchanged: boolean;
  considerationType: string;
  maintainOriginalExitDetails: boolean;
} & SharedShareConsiderationFields;

export type Mutation = {
  mutate: (
    data: StageAmendmentInput,
    options: {
      onSuccess: (data: Array<StagedShareholding>) => void;
    },
  ) => void;
};

export const stageAmendment = (
  mutation: Mutation,
  exitId: string | undefined,
  exitDetails: ExitDetailsFormValues,
  previousExitDetails: Partial<ExitDetailsFormValues>,
  sharedShareConsiderationFields: SharedShareConsiderationFields,
  setInitialShareholdings: (data: Array<StagedShareholding>) => void,
) => {
  if (!exitId) {
    return;
  }
  mutation.mutate(
    {
      exitId,
      exitDate: format(exitDetails.exitDate, 'dd/MM/yyyy'),
      firmId: exitDetails.firmId,
      sharePrice: Number(exitDetails.sharePrice),
      taxableValueSharePrice: Number(exitDetails.taxableValueSharePrice),
      isReceivedValueSharePriceUnchanged:
        exitDetails.sharePrice === previousExitDetails?.sharePrice,
      considerationType:
        exitDetails.considerationType ?? ConsiderationType.Cash,
      maintainOriginalExitDetails: false,
      ...sharedShareConsiderationFields,
    },
    {
      onSuccess: (data: Array<StagedShareholding>) => {
        const formattedInitialShareholdingData: Array<StagedShareholding> =
          data?.map((sh) => ({
            ...sh,
            // Do NOT override investorTotalAccruedFees from the backend response
            // It contains the investment-level max that should be shown as the limit for all shareholdings
          })) ?? [];
        setInitialShareholdings(formattedInitialShareholdingData);
      },
    },
  );
};
